import { clearLocalStorageExcept } from "./logoutUtil";

// 채널 종류 상수 정의: VD, DA
export const CHANNEL = {
    VD: "VD",
    DA: "DA",
};

// 로컬스토리지에서 토큰 가져오기
const getToken = () => {
    return localStorage.getItem("token");
}

// 로컬스토리지에서 채널 정보 가져오기
export const getChannel = () => {
    return localStorage.getItem("channel");
}

// 로컬스토리지에 채널 정보 저장 (기본값: VD)
export const setChannel = (channel = CHANNEL.VD) => {
    localStorage.setItem("channel", channel);
}

/**
 * 자동 로그인 처리 함수
 * 
 * @param {Function} next - Vue Router의 next 함수
 * @param {Object} to - 현재 이동 대상 라우터 정보 객체 (query 등 포함)
 */
export const handleAutoLogin = async (next, to) => {
    try {
        const token = getToken();
        const channel = getChannel();

        // 1. ?clearStorage=true 쿼리가 있을 경우: 
        //    DA 로그인 화면에서 X 버튼을 눌러 VD 브랜드 선택화면으로 넘어온 케이스 -> 로컬스토리지 초기화
        if (to.query && to.query.clearStorage) {
            clearLocalStorageExcept();
            return next(); // 그대로 진행
        }

        // 2. 채널이 DA인 경우 (앱 또는 관리자 환경)
        if (channel === CHANNEL.DA) {
            // 로컬 환경인지 여부에 따라 DA 이동 경로 설정
            const loginOrigin = location.host.includes("localhost")
                ? "http://localhost:8081/#/home"
                : `${process.env.VUE_APP_DA_HOST}/#/home`;

            // 쿼리에서 전달된 tokens와 deviceOS를 추출
            const tokens = to.query && to.query.tokens;
            const deviceOS = to.query && to.query.deviceOS;

            // URL 파라미터 구성
            const queryParams = new URLSearchParams();

            if (tokens) queryParams.append("tokens", tokens);
            if (deviceOS) queryParams.append("deviceOS", deviceOS);

            // 내부 이동이라는 의미로 linkType 명시
            queryParams.set("linkType", "INTERNAL_LINK");

            // 채널 정보를 로컬스토리지에 저장 (DA로 명시)
            setChannel(CHANNEL.DA);

            // DA 홈 화면으로 강제 이동
            window.location.href = `${loginOrigin}?${queryParams.toString()}`;

        // 3. 채널이 VD이고 토큰이 존재하는 경우 -> VD 홈 화면으로 이동
        } else if (channel === CHANNEL.VD && token) {
            next("/home");

        // 4. 토큰 없고 VD 채널이거나 채널이 아예 없는 경우 -> 다음 라우팅 단계로 진행
        } else {
            next();
        }

    } catch (error) {
        console.log("Handle Auto Login Error : ", error);
        // 에러 발생 시에도 기본 흐름을 유지
        next();
    }
}
